<template>
    <div class="uk-container uk-container-expand summary-report">
        <div class="row top-row">
            <div class="cell">
                <div class="count">{{ businessUnits }}</div>
                <label>Active Business Units</label>
                <div class="separator"></div>
            </div>
            <div class="cell">
                <div class="count">{{ openJobs }}</div>
                <label>Open Jobs</label>
                <div class="separator"></div>
            </div>
            <div class="cell" :class="{'cell-primary':currentCell == 'active-emps'}">
                <div class="count">{{ activeEmployees }}</div>
                <label>Active Employees</label>
                <div class="separator"></div>
            </div>
            <div class="cell" :class="{'cell-primary':currentCell == 'inactive-emps'}">
                <div class="count">{{ inactiveEmployees }}</div>
                <label>Non-Active Employees</label>
                <div class="separator"></div>
            </div>
            <div class="cell">
                <div class="count">{{ activeCrafts }}</div>
                <label>Active Crafts</label>
            </div>
        </div>

        <div class="row tab-row uk-margin-medium-top">
            <div class="cell" @click="setCell('active-emps')" :class="{'cell-primary':currentCell == 'active-emps'}">
                <label>Active Employees</label>
                <transition name="fade">
                    <div v-if="currentCell == 'active-emps'" class="cell-primary-separator"><i class="fas fa-caret-down"></i></div>
                </transition>
            </div>
            <div class="cell" @click="setCell('inactive-emps')" :class="{'cell-primary':currentCell == 'inactive-emps'}">
                <label>Non-Active Employees</label>
                <transition name="fade">
                    <div v-if="currentCell == 'inactive-emps'" class="cell-primary-separator"><i class="fas fa-caret-down"></i></div>
                </transition>
            </div>
        </div>
        <div class="row-container uk-margin-medium-bottom">
            <transition name="fade">
                <div v-if="currentCell == 'active-emps'" class="row bottom-row">
                    <div v-for="(stat, i) in activeEmployeeStats" class="cell">
                        <div class="count">
                            {{ stat.count }}
                        </div>
                        <label>{{ stat.name }}</label>
                        <div v-if="i < activeEmployeeStats.length -1" class="separator"></div>
                    </div>
                </div>
            </transition>
            <transition name="fade">
                <div v-if="currentCell == 'inactive-emps'" class="row bottom-row">
                    <div v-for="(stat, i) in inactiveEmployeeStats" class="cell">
                        <div class="count">
                            {{ stat.count }}
                        </div>
                        <label>{{ stat.name }}</label>
                        <div v-if="i < inactiveEmployeeStats.length -1" class="separator"></div>
                    </div>
                </div>
            </transition>
        </div>

    </div>
</template>

<script>
    export default {
        name: "DashboardNumbers",

        props:{
            businessUnits:{
                type:String,
                default:"0"
            },
            openJobs:{
                type:String,
                default:"0"
            },
            activeEmployees:{
                type:String,
                default:"0"
            },
            activeCrafts:{
                type:String,
                default:"0"
            },
            inactiveEmployees:{
                type:String,
                default:"0"
            },
            activeEmployeeStats:{
                type:Array,
                default:() => []
            },
            inactiveEmployeeStats:{
                type:Array,
                default:() => []
            },
        },

        components: {},

        data() {
            return {
                currentCell:"active-emps"
            };
        },

        mounted() {

        },

        methods: {
            setCell(cell){
                this.currentCell = cell;
            }
        }
    }
</script>
